// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// HS Code
import { LanguageModel, SelectListItem } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class LanguagesBaseService {

  protected _selectedLanguage$: BehaviorSubject<LanguageModel>;
  get selectedLanguage$(): Observable<LanguageModel> {
    return this._selectedLanguage$.asObservable();
  }

  protected _languages$: BehaviorSubject<LanguageModel[]>;
  get languages$(): Observable<LanguageModel[]> {
    return this._languages$.asObservable();
  }

  protected _languagesList$: BehaviorSubject<SelectListItem[]>;
  get languagesList$(): Observable<SelectListItem[]> {
    return this._languagesList$.asObservable();
  }

  constructor() {
    this._languages$ = new BehaviorSubject<LanguageModel[]>(null);
    this._selectedLanguage$ = new BehaviorSubject<LanguageModel>(null);
    this._languagesList$ = new BehaviorSubject<SelectListItem[]>(null);
  }

  protected _processLanguages(languages: LanguageModel[]) {
    const languageList = new Array<SelectListItem>();
    languages.forEach(l => {
      const selectedId = this._selectedLanguage$.value && this._selectedLanguage$.value.id;
      const selectListItem = {
        text: l.nativeName,
        value: l.id.toString(),
        isSelected: l.id === selectedId
      } as SelectListItem;
      languageList.push(selectListItem);
    });
    this._languagesList$.next(languageList);
  }

  abstract initialiseLanguage(selectedLanguageId: number): void;
  abstract setSelectedLanguage(selectedLanguage: LanguageModel): void;

  abstract loadLanguages(): void;
}
